import { useEffect, useState } from "react";
import { FormDetailViewModelProps } from "./FormDetail.component";
import { useServiceContext } from "../../../../contexts/ServiceContext";
import { FormDetailComponentState } from "../../../components/form-detail/FormDetailComponentState";
import { useNavigate, useParams } from "react-router-dom";

import { Form } from "../../../../core/entities/form";

export function useFormDetailViewModel(): FormDetailViewModelProps {
    const [form, setForm] = useState<Form | undefined>();
    const [componentState, setComponentState] =
        useState<FormDetailComponentState>(FormDetailComponentState.Loading);
    const { formService } = useServiceContext();
    const navigate = useNavigate();
    let { formId } = useParams();

    useEffect(() => {
        formService
            .getById(formId!)
            .then((result) => {
                setComponentState(FormDetailComponentState.Found);
                setForm(result);
            })
            .catch((e) => {
                let compState = FormDetailComponentState.Error;
                switch (e.status) {
                    case 403:
                        compState = FormDetailComponentState.Forbidden;
                        break;
                    case 404:
                        compState = FormDetailComponentState.NotFound;
                        break;
                }
                setComponentState(compState);
            });
    }, [formId, formService]);

    function handleBackButton(): void {
        // @ts-ignore
        const s = window.history.state["usr"];

        if (s) {
            navigate(-1);
        } else {
            navigate("/forms");
        }
    }

    return {
        componentState,
        form,
        handleBack: handleBackButton
    };
}
